const deDE = {
  locale: 'en-ZA',
  productsAddedToBasket: {
    one: '[de-DE] 1 product added to your basket',
    other: '[de-DE] {count} products added to your basket'
  },
  basketItems: {
    one: '[de-DE] 1 item in your basket',
    other: '[de-DE] {count} items in your basket'
  },
  fakeStockItem: {
    one: '[de-DE] 1 in stock on {date}',
    other: '[de-DE] {count} in stock on {date}'
  },
  productStockInStock: {
    one: '[de-DE] {count} in stock',
    other: '[de-DE] {count} in stock'
  },
  productStockDueStock: {
    one: '[de-DE] {count} Due: {date}',
    other: '[de-DE] {count} Due: {date}'
  },
  searchProductDueStock: {
    one: '[de-DE] Stock due {date}',
    other: '[de-DE] Stock due on {date}'
  },
  filterViewResults: {
    one: '[de-DE] View {count} Result',
    other: '[de-DE] View {count} Results'
  },
  bulkBuyPack: {
    one: '[de-DE] {count} pack',
    other: '[de-DE] {count} pack'
  }
};

export default deDE;
